export default __webpack_public_path__ + "icon_market_selector.fc929cf8072c828899c2eaa5254fd165.svg";